import {useAppDispatch, useAppSelector} from '@/redux/reduxUtils';
import {setActiveAssessmentId as setActiveAssessmentIdAction} from '@/redux/slices/director';
import {useCallback} from 'react';

export const useGlobalActiveAssessmentState = () => {
  const dispatch = useAppDispatch();
  const globalActiveAssessmentId = useAppSelector((state) => state.directorReducer.activeAssessmentId);

  const setGlobalActiveAssessmentId = useCallback(
    (activeAssessmentId: string) => {
      dispatch(setActiveAssessmentIdAction(activeAssessmentId));
    },
    [dispatch]
  );

  return {setGlobalActiveAssessmentId, globalActiveAssessmentId};
};
